<template>
    <div id="visit-attachments-hh">
        <div class="doc-header py-1">
            <div class="mb-3"><h6 class="d-inline mr-auto">Attachments</h6></div>

            <div v-if="!loadingAttachments">
                <span>There are {{ taskAttchments.length }} attachment(s).</span>
                <div v-for="attachment in taskAttchments" :key="attachment.AssetId">
                    <a href="javascript:void(0);" @click="downloadDocuments(attachment)">{{ attachment.FileName }}</a>
                    |
                    <button
                        type="button"
                        class="btn table-btn btn-outline-info au-target"
                        @click="openSelectedDocument(attachment)"
                        v-tooltip="{ title: 'View' }"
                    >
                        <i class="fa fa-eye"></i>
                    </button>
                    <template v-if="deletePatientDocumentsPermission || editPatientDocumentsPermission">
                        |
                        <span
                            v-if="isDeleteInProgress && attachmentToDelete === attachment?.AssetId"
                            class="blinking-content"
                            >Deleting document...</span
                        >
                        <a href="javascript:void(0);" v-else @click="requestDelete(attachment)" :disabled="isPlanner"
                            >Delete</a
                        >
                    </template>
                </div>
            </div>
            <div v-else>
                <p>Loading attachments...</p>
                <div v-for="i in loadingCount" :key="i">
                    <span class="shimmer-loading block-size-8"></span>
                </div>
            </div>
        </div>
        <div class="doc-body mt-3">
            <div v-if="addPatientDocumentsPermission">
                <span> Use the upload field below to upload files associated with the schedule task. </span>
                <div class="upload-document mt-1">
                    <input
                        type="file"
                        ref="file1"
                        :disabled="uploading || isPlanner"
                        @change="uploadFilesChanged($event)"
                        class="file-input border my-1 d-block"
                    />
                </div>
                <div class="mt-2 py-2">
                    <span v-if="uploading">
                        <button class="btn btn-primary">
                            <i class="fa fa-spinner fa-spin animated slow flash infinite"></i>
                        </button>
                    </span>
                    <span v-else>
                        <button class="btn btn-primary" @click="saveAttachments()" :disabled="isPlanner">
                            Save Attachment
                        </button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./VisitAttachmentsHH.ts" />
<style lang="scss" src="./VisitAttachmentsHH.scss" />
